import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';

/** Must match AuthService encrypt. No hardcoded fallback: builds must set REACT_APP_ENCRYPTION_KEY. */
export const TOKEN_ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY || '';

if (!TOKEN_ENCRYPTION_KEY) {
  console.error('REACT_APP_ENCRYPTION_KEY is not set; tokens cannot be stored.');
}

export const encryptToken = (token) => {
  if (!token || !TOKEN_ENCRYPTION_KEY) return '';
  return AES.encrypt(token, TOKEN_ENCRYPTION_KEY).toString();
};

export const decryptToken = (encryptedToken) => {
  if (!TOKEN_ENCRYPTION_KEY) return null;
  try {
    const decryptedToken = AES.decrypt(
      encryptedToken,
      TOKEN_ENCRYPTION_KEY
    ).toString(Utf8);
    return decryptedToken || null;
  } catch (error) {
    console.error('Error decrypting token', error);
    return null;
  }
};
